/**
 * @fileoverview gRPC-Web generated client stub for proto.services
 * @enhanceable
 * @public
 */

// GENERATED CODE -- DO NOT EDIT!


/* eslint-disable */
// @ts-nocheck


import * as grpcWeb from 'grpc-web';

import * as google_protobuf_empty_pb from 'google-protobuf/google/protobuf/empty_pb';
import * as proto_services_captcha_service_pb from '../../proto/services/captcha_service_pb';


export class CaptchaServiceClient {
  client_: grpcWeb.AbstractClientBase;
  hostname_: string;
  credentials_: null | { [index: string]: string; };
  options_: null | { [index: string]: any; };

  constructor (hostname: string,
               credentials?: null | { [index: string]: string; },
               options?: null | { [index: string]: any; }) {
    if (!options) options = {};
    if (!credentials) credentials = {};
    options['format'] = 'text';

    this.client_ = new grpcWeb.GrpcWebClientBase(options);
    this.hostname_ = hostname;
    this.credentials_ = credentials;
    this.options_ = options;
  }

  methodInfoCreateCaptcha = new grpcWeb.MethodDescriptor(
    '/proto.services.CaptchaService/CreateCaptcha',
    grpcWeb.MethodType.UNARY,
    proto_services_captcha_service_pb.CreateCaptchaRequest,
    google_protobuf_empty_pb.Empty,
    (request: proto_services_captcha_service_pb.CreateCaptchaRequest) => {
      return request.serializeBinary();
    },
    google_protobuf_empty_pb.Empty.deserializeBinary
  );

  createCaptcha(
    request: proto_services_captcha_service_pb.CreateCaptchaRequest,
    metadata: grpcWeb.Metadata | null): Promise<google_protobuf_empty_pb.Empty>;

  createCaptcha(
    request: proto_services_captcha_service_pb.CreateCaptchaRequest,
    metadata: grpcWeb.Metadata | null,
    callback: (err: grpcWeb.RpcError,
               response: google_protobuf_empty_pb.Empty) => void): grpcWeb.ClientReadableStream<google_protobuf_empty_pb.Empty>;

  createCaptcha(
    request: proto_services_captcha_service_pb.CreateCaptchaRequest,
    metadata: grpcWeb.Metadata | null,
    callback?: (err: grpcWeb.RpcError,
               response: google_protobuf_empty_pb.Empty) => void) {
    if (callback !== undefined) {
      return this.client_.rpcCall(
        this.hostname_ +
          '/proto.services.CaptchaService/CreateCaptcha',
        request,
        metadata || {},
        this.methodInfoCreateCaptcha,
        callback);
    }
    return this.client_.unaryCall(
    this.hostname_ +
      '/proto.services.CaptchaService/CreateCaptcha',
    request,
    metadata || {},
    this.methodInfoCreateCaptcha);
  }

}

